module.exports = __webpack_public_path__ + "img/Play_Video.bd86b546.svg";